export const MULTI_SELECT_CHECKBOX_SIZE = 12;
export const SELECT_DROPDOWN_MAX_HEIGHT = 300;
